import { parseFieldProps } from './object'
import { toTitleCase } from './string'

/**
 * @deprecated Needs to be deleted once deleting the getComparator method in this file
 */
export const extendFieldGroup = (
  fieldGroup,
  fieldGroupExtensions,
  state,
  prevState,
) =>
  Object.entries(fieldGroup).reduce(
    (acc, [name, field]) => {
      const extender = fieldGroupExtensions[name] || {}
      const fieldProps = parseFieldProps({ field, state, prevState })
      if (!fieldProps) {
        return acc
      }
      acc[name] =
        typeof extender === 'function'
          ? extender(fieldProps)
          : { ...fieldProps, ...extender }
      return acc
    },
    { ...fieldGroup },
  )

/**
 * @deprecated field groups can be conditionally defined as function that takes the form state
 */
export const applyFieldGroupExtensions = (
  fieldGroups,
  fieldGroupExtensions,
  state,
  prevState,
) =>
  fieldGroups.reduce((acc, crr) => {
    if (Array.isArray(crr)) {
      const [fieldGroupId, fieldGroup, repeatableFieldGroupProps] = crr
      const { [fieldGroupId]: extendedFieldGroup } = extendFieldGroup(
        { [fieldGroupId]: fieldGroup },
        fieldGroupExtensions,
        state,
        prevState,
      )
      acc.push([fieldGroupId, extendedFieldGroup, repeatableFieldGroupProps])
    } else {
      acc.push(extendFieldGroup(crr, fieldGroupExtensions, state, prevState))
    }

    return acc
  }, [])

const layoutElements = new Set(['heading', 'paragraph', 'divider'])

/**
 * @deprecated Needs to be deleted once deleting the getApplicationData method in this file
 */
const appDataDefaultData = (fieldGroup, appData) =>
  Object.entries(fieldGroup).reduce((acc, [key, val]) => {
    const type = typeof val === 'object' ? val.type : val
    if (layoutElements.has(type)) {
      return acc
    }
    if (typeof appData[key] === 'boolean') {
      acc[key] = appData[key] ? 'yes' : 'no'
      return acc
    }
    acc[key] = appData[key] || ''
    return acc
  }, {})

/**
 * @deprecated Needs to be deleted once refactoring the OwnerInfoModal.jsx and PersonalInformationTab.jsx
 */
export const getApplicationData = (applicationData, fieldGroups = []) =>
  applicationData
    ? fieldGroups.reduce((acc, cur) => {
        if (Array.isArray(cur)) {
          const [key, fieldGroup] = cur
          const data = applicationData[key] || [{}]
          const defaultData = data.map(obj =>
            appDataDefaultData(fieldGroup, obj),
          )

          return { ...acc, [key]: defaultData }
        }

        return {
          ...acc,
          ...appDataDefaultData(cur, applicationData),
        }
      }, {})
    : {}

/**
 * @deprecated Needs to be deleted once refactoring the ApplicationSteps components
 */
export const getFieldNamesFromFieldGroups = fieldGroups =>
  fieldGroups.reduce((acc, cur) => {
    if (Array.isArray(cur)) {
      const [key] = cur
      return [...acc, key]
    }

    return [...acc, ...Object.keys(cur)]
  }, [])

/**
 * @deprecated Needs to be deleted once deleting the getComparator method in this file
 */
const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

/**
 * @deprecated Needs to be deleted once moving out of the legacy Table.jsx
 */
export const getComparator = (order, orderBy) =>
  order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)

/**
 * @notes Legacy notes - This method is created for cross-browser compatibility, if you don't need to support IE11, you can use Array.prototype.sort() directly
 * @deprecated Needs to be deleted once moving out of the legacy Table.jsx
 */
export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

// eslint-disable-next-line import/no-extraneous-dependencies
export { range } from '@harvestiq/utils/range'

/**
 * @deprecated Prefer using explicitly defined options instead of this utility
 */
export const parseOptions = options =>
  Array.isArray(options)
    ? options.map(option =>
        typeof option === 'object'
          ? option
          : { value: option, label: toTitleCase(option) },
      )
    : Object.entries(options).map(([value, label]) => ({
        value,
        label,
      }))

export const sum = vals => vals.reduce((currentSum, v) => currentSum + v, 0)

/**
 * @deprecated Prefer using lodash's intersection or Set intersection for better performance
 */
export const intersects = (a, b) => {
  const setB = new Set(b)
  return [...new Set(a)].filter(x => setB.has(x))
}
